export const backgroundStarsTemplateVideoLink =
  "https://www.youtube.com/watch?v=aywzn9cf-_U";

export const openWeatherAPILink = "https://openweathermap.org/api";
